import {
  BatchStateResponse,
  CheckBatchHistoryResponse,
  CheckBatchItem,
} from '@/api';
import { CheckBatchHistoryData, CheckBatchHistoryItem } from '../models';

const mapBatchItem = (data: CheckBatchItem): CheckBatchHistoryItem => {
  return {
    id: data.id,
    status: Number(data.status),
    progress: Number(data.progress),
    filename: data.filename,
    created: data.created,
  };
};

const checkBatchHistory = (
  response: CheckBatchHistoryResponse,
): CheckBatchHistoryData => {
  const { data } = response;
  const list = data.batches as CheckBatchItem[];

  const mappedData: CheckBatchHistoryData = {
    items: list.map(mapBatchItem).sort((a, b) => b.created - a.created),
  };

  return mappedData;
};

export { mapBatchItem, checkBatchHistory };
